// Supplier-related constants
export const SUPPLIER_LIMITS = {
  V1: 6,
  V2: 24,
  // Maximum number of offline suppliers to backfill
  MAX_OFFLINE_V1: 6,
  MAX_OFFLINE_V2: 24,
} as const;

// For backwards compatibility and easy access
export const MAX_SUPPLIERS_V1 = SUPPLIER_LIMITS.V1;
export const MAX_SUPPLIERS_V2 = SUPPLIER_LIMITS.V2;
export const MAX_OFFLINE_SUPPLIERS_V1 = SUPPLIER_LIMITS.MAX_OFFLINE_V1;
export const MAX_OFFLINE_SUPPLIERS_V2 = SUPPLIER_LIMITS.MAX_OFFLINE_V2;
